// npm
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { Modal } from '../_libs/Modal';

// css
import '../../scss/pages/page-reason.scss';

// utils
import foundation from '../_utils/foundation';
import Ease from '../_utils/Ease';
foundation();

document.addEventListener('DOMContentLoaded', () => {
	const fvModal = new Modal({
		modal: '.js-reason-modal',
		open: '.js-reason-modal-open',
		close: '.js-reason-modal-close',
		html: 'is-reason-modal-open',
		overlay: '.js-reason-modal-overlay',
		globalContainer: '.js-container',
	});
	fvModal.init();

	const $fv = document.querySelector('.js-fv');
	if ($fv) {
		const $headline = $fv.querySelector('.js-fv-headline');
		const $headlineEn = $headline.querySelector('.js-fv-headline-en');
		const $headlineJa = $headline.querySelector('.js-fv-headline-ja');
		const $enChar = $headlineEn.querySelectorAll('.char');
		const $fvfade = $headline.querySelectorAll('.js-fv-fade');

		function fvAnimation() {
			gsap.set($headline, {
				opacity: 1,
			});

			gsap.fromTo(
				$enChar,
				{
					display: 'inline-block',
					yPercent: 101,
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					stagger: 0.032,
					delay: 0.3,
				}
			);

			gsap.fromTo(
				$headlineJa,
				{
					yPercent: 101,
					display: 'inline-block',
				},
				{
					yPercent: 0,
					duration: 1,
					ease: Ease.gleasing,
					delay: 0.7,
				}
			);

			gsap.fromTo(
				$fvfade,
				{
					opacity: 0,
					y: 20,
				},
				{
					opacity: 1,
					y: 0,
					duration: 1,
					ease: Ease.DoubleSineOut,
					delay: 0.8,
				}
			);
		}

		setTimeout(() => {
			fvAnimation();
		}, 400);
	}

	const $copy = document.querySelector('.js-copy');
	if ($copy) {
		const $head = $copy.querySelector('.js-copy-head');

		ScrollTrigger.create({
			trigger: $head,
			onEnter: () => {
				$head.classList.add('is-show');
			},
		});
	}

	const $$real = document.querySelectorAll('.js-real');
	if ($$real.length > 0) {
		$$real.forEach(($real) => {
			const $$headline = $real.querySelectorAll('.js-real-headline');
			const $$lines = $real.querySelectorAll('.js-line');
			const $$paths = $real.querySelectorAll('.js-path');

			gsap.set($$headline, {
				yPercent: 120,
				opacity: 1,
			});

			gsap.set($$lines, {
				xPercent: -120,
				opacity: 1,
			});

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							gsap.to($$headline, {
								yPercent: 0,
								duration: 1,
								ease: Ease.gleasing,
								onStart: () => {
									// アニメーションが完了したときに複数の .js-line にクラスを追加
									$$paths.forEach(($path) => {
										$path.classList.add('is-path');
									});
								},
							});

							// アニメーション: .js-line
							gsap.to($$lines, {
								xPercent: 0,
								duration: 1,
								ease: Ease.gleasing,
								delay: 0.4,
							});

							observer.disconnect();
						}
					});
				},
				{
					rootMargin: '0px 0px -20% 0px',
				}
			);

			observer.observe($real);
		});
	}
});

window.addEventListener('load', () => {});
